module.exports = __webpack_public_path__ + "img/ad08.72feeea9.png";